import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {
    setFixedAssetMovementsReportAutoLoad,
    setFixedAssetMovementsReportRequestData,
    setFixedAssetMovementsReportResponseData
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import moment from "moment";
import Pagination from "../../../primer/Pagination";
import {getGreekCurrencyFormat, hookCompanyLogo, isEmpty} from "../../../../_helpers/commonFunctions";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import ReportsTemplate from "../../../common/ReportsTemplate";
import * as XLSX from "xlsx";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {openFixedAssetMovement, openFixedAssetRecord} from "../../../../_helpers/tabOpeners";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import BetterCheckBox from "../../../common/BetterCheckBox";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";

const ReportFixedAssetMovements = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const fixedAssetMovementsReportAutoLoad = useSelector((state) => state.FIXED_ASSETS.fixedAssetMovementsReportAutoLoad);

    const requestData = useSelector((state) => state.FIXED_ASSETS.fixedAssetMovementsReportRequestData[tabKey]);
    const responseData = useSelector((state) => state.FIXED_ASSETS.fixedAssetMovementsReportResponseData[tabKey]);
    const setRequestData = (data) => dispatch(setFixedAssetMovementsReportRequestData(data));
    const setResponseData = (data) => dispatch(setFixedAssetMovementsReportResponseData(data));

    const installationOptions = useInstallationOptions(true);

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);

    useEffect(() => {
        if (isEmpty(requestData.date_from) && isEmpty(requestData.date_to)) {
            setRequestData({
                ...requestData,
                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
            })
        }
        if (fixedAssetMovementsReportAutoLoad) setPageChanged(true);
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (fixedAssetMovementsReportAutoLoad) {
            const split = String(fixedAssetMovementsReportAutoLoad).split("|");
            reqData.page = 1;
            reqData.name = split[0];
            reqData.code = split[1];
            dispatch(setFixedAssetMovementsReportAutoLoad(""));
            setRequestData(reqData);
        }
        if (!fromPagination) {
            reqData.page = 1;
            setRequestData(reqData);
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-movements`, {
            headers: { "Content-Type": "application/json" },
            params: {
                ...reqData,
                company: company.id,
                year: company.year,
            }
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                if (!fromPagination) toast.success("Επιτυχής ανανέωση δεδομένων.", {autoClose: 1000});
                setResponseData({...responseData, data: res.data.data, totalPages: res.data.totalPages, fixedAsset: res.data.fixedAsset});
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        }
        setRequestData({...requestData, ...prepChange});
    }

    const dataCollectForExport = async () => {
        const totalData = [];
        try {
            for (let page = 1; page <= responseData.totalPages; page++) {
                const resp = await axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/report-movements`, {
                    headers: { "Content-Type": "application/json" },
                    params: {
                        ...requestData,
                        page: page,
                        company: company.id,
                        year: company.year,
                    }
                });
                if (resp.data.status === "200") {
                    totalData.push(resp.data);
                }
            }
        } catch (err) {
            console.log(err);
        }
        return totalData;
    }

    const getRowTypeName = (obj) => {
        if (obj.type === "assetMovement") {
            return "Κίνηση Παγίων";
        } else if (obj.type === "assetRecord") {
            return "Απόσβεση";
        } else if (obj.type === "addition") {
            return "Προσθήκη Παγίου";
        } else if (obj.type === "improvement") {
            return "Βελτίωση Παγίου";
        } else if (obj.type === "previousBalance") {
            return "Από μεταφορά";
        } else if (obj.type === "totals") {
            return "Σύνολο";
        } else {
            return obj.type;
        }
    }

    const handleExcelExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            const dateExported = moment().format("DD/MM/YYYY HH:mm:ss");
            rows.push(["Επωνυμία:", company.name]);
            rows.push(["ΑΦΜ:", company.vatNumber]);
            rows.push(["Ημερομηνία Εξαγωγής:", dateExported]);
            for (const tData of totalData) {
                rows.push([]);
                let str = `Πάγιο: ${tData.fixedAsset.name} (${getGreekCurrencyFormat(tData.fixedAsset.acquisitionCost)})`;
                if (tData.fixedAsset.systemCode) str += ` - ${tData.fixedAsset.systemCode}`;
                if (tData.fixedAsset.manualCode) str += ` - ${tData.fixedAsset.manualCode}`;
                rows.push([str])
                rows.push(["Αρ.", "Ημερομηνία", "Τύπος Κίνησης", "Πληροφορίες Εγγραφής", "Εγκατάσταση", "Ποσό", "Αποσβεσμένο Ποσό", "Υπόλοιπο"]);
                let num = 1;
                for (let row of tData.data) {
                    rows.push([
                        num,
                        moment(row.date).format("DD/MM/YYYY"),
                        getRowTypeName(row),
                        row.documentLabel,
                        installationOptions.find((el) => el.value === row.installation)?.label,
                        getGreekCurrencyFormat(row.amount),
                        getGreekCurrencyFormat(row.accumulatedDepreciation),
                        getGreekCurrencyFormat(row.balance),
                    ])
                    num++;
                }
            }
            const workSheet = XLSX.utils.aoa_to_sheet(rows);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, "Κινήσεις Παγίων");
            XLSX.writeFile(workBook, 'Κινήσεις Παγίων.xlsx');
        }
        setLoadingPrint(false);
    }

    const handlePDFExport = async () => {
        setLoadingPrint(true);
        const totalData = await dataCollectForExport();
        if (totalData.length > 0) {
            let rows = [];
            let idx = 0;
            for (const tData of totalData) {
                tData.data = tData.data.filter((el) => el.type !== "totals");
                let str = `Πάγιο: ${tData.fixedAsset.name} (${getGreekCurrencyFormat(tData.fixedAsset.acquisitionCost)})`;
                if (tData.fixedAsset.systemCode) str += ` - ${tData.fixedAsset.systemCode}`;
                if (tData.fixedAsset.manualCode) str += ` - ${tData.fixedAsset.manualCode}`;
                rows.push([{content: str, colSpan: 8, styles: {halign: "left", fillColor: "#decae3"}}])
                let num = 1;
                for (let row of tData.data) {
                    rows.push([
                        num,
                        moment(row.date).format("DD/MM/YYYY"),
                        getRowTypeName(row),
                        row.documentLabel,
                        installationOptions.find((el) => el.value === row.installation)?.label,
                        getGreekCurrencyFormat(row.amount),
                        getGreekCurrencyFormat(row.accumulatedDepreciation),
                        getGreekCurrencyFormat(row.balance),
                    ])
                    num++;
                }
                rows.push([
                    {content: `Σύνολο παγίου ${tData.fixedAsset.name}`, colSpan: 5, styles: {fillColor: "#decae3"}},
                    {content: getGreekCurrencyFormat(tData.data.reduce((sum, obj) => sum + (obj.amount || 0), 0)), colSpan: 1, styles: {fillColor: "#decae3"}},
                    {content: "", colSpan: 2, styles: {fillColor: "#decae3"}},
                ])
                if (idx !== totalData.length - 1) rows.push([]);
                idx++;
            }

            const headerColumns = ["Αρ.", "Ημερομηνία", "Τύπος Κίνησης", "Πληροφορίες Εγγραφής", "Εγκατάσταση", "Ποσό", "Αποσβεσμένο Ποσό", "Υπόλοιπο"];
            const doc = new jsPDF('landscape');
            let y = 20;

            doc.addFileToVFS("arialuni.ttf", liberationSerif);
            doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
            doc.addFileToVFS("dejavusans.ttf", dejavuSans);
            doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
            doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
            doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

            hookCompanyLogo(doc, companyDetails);

            const imgData = 'assets/images/prrimer-logo.png';
            const primerWidth = 28;
            const primerHeight = 10;
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
            doc.setFont("DejaVu Sans Bold");
            doc.setFontSize(10);
            const header = doc.splitTextToSize("Κινήσεις Παγίων", 200);
            const headerString = header.join("\n");
            doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
            doc.setFont("DejaVu Sans Normal");

            autoTable(doc, {
                startY: y,
                head: [headerColumns],
                body: rows,
                rowPageBreak: "avoid",
                styles: {
                    font: "DejaVu Sans Normal",
                    fontStyle: "normal",
                    fontSize: 8,
                    halign: "center",
                },
            })

            const pageCount = doc.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(10);
                doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
            }

            doc.save(`Κινήσεις Παγίων.pdf`);
        }
        setLoadingPrint(false);
    }

    const handlePageChange = (page) => {
        setRequestData({...requestData, page: page});
        setPageChanged(true);
    }

    const handleDocClick = (row) => {
        if (row.type === "assetMovement") {
            openFixedAssetMovement(dispatch, TABS_DATA, company.id, row._id);
        } else if (row.type === "assetRecord") {
            openFixedAssetRecord(dispatch, TABS_DATA, company.id, row._id);
        }
    }

    return (
        <div>
            <ReportsTemplate
                templateType={"report-fixed-asset-movements"}
                requestData={requestData}
                fetchReport={() => fetchReport()}
                setRequestData={(data) => setRequestData(data)} header={"Κινήσεις Παγίων"}
            />
            <Row onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => setRequestData({...requestData, date_from: from, date_to: to})}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_from"}
                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία από"}
                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_to"}
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                        label={"Ημερομηνία έως"}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"name"}
                        label={"Όνομα Παγίου"}
                        value={requestData.name}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"code"}
                        label={"Κωδικός Συστήματος/Χειροκίνητος Κωδικός Παγίου"}
                        value={requestData.code}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "code")}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"installation"}
                        label={"Εγκατάσταση"}
                        options={installationOptions}
                        key={requestData.installation}
                        defaultValue={installationOptions.find((el) => el.value === requestData.installation)}
                        onChange={(e) => handleOnChange(e, "dd", "installation")}
                    />
                </Col>
                <Col md={3}>
                    <div style={{marginTop: "33px"}}>
                        <BetterCheckBox
                            name={"include_zero_balance"}
                            text={"Συμπερίληψη αποσβεσμένων παγίων"}
                            checked={requestData.include_zero_balance}
                            onChange={(e) => handleOnChange(e, "cb", "include_zero_balance")}
                        />
                    </div>
                </Col>
            </Row>
            <Row className={"d-flex justify-content-end"}>
                <Col md={3} className={"d-flex justify-content-end"}>
                    <Button style={{marginTop: "23px"}} onClick={() => fetchReport(false)} disabled={loading}>
                        Εφαρμογή Φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Col>
            </Row>
            {responseData.data.length > 0 && (
                <React.Fragment>
                    <hr/>
                    <Row>
                        <Col md={6}>
                            <div style={{fontSize: "16px"}}>
                                <strong>Όνομα Παγίου:</strong> {responseData.fixedAsset?.name}<br/>
                                <strong>Κωδικός Συστήματος:</strong> {responseData.fixedAsset?.systemCode}<br/>
                                {!isEmpty(responseData.fixedAsset?.manualCode) && (
                                    <span><strong>Χειροκίνητος Κωδικός:</strong> {responseData.fixedAsset?.manualCode}<br/></span>
                                )}
                                <strong>Ποσότητα: </strong> {responseData.fixedAsset?.quantity || 1}<br/>
                                <strong>Κόστος Κτήσης:</strong> {getGreekCurrencyFormat(responseData.fixedAsset?.acquisitionCost)}<br/>
                            </div>
                        </Col>
                        <Col md={6} className={"d-flex justify-content-end"}>
                            <Pagination
                                currentPage={requestData.page}
                                totalPages={responseData.totalPages}
                                handlePageChange={(page) => handlePageChange(page)}
                            />
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableGrayHover"}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αρ.</th>
                                    <th>Ημερομηνία</th>
                                    <th>Τύπος Κίνησης</th>
                                    <th>Πληροφορίες Εγγραφής</th>
                                    <th>Εγκατάσταση</th>
                                    <th>Ποσό</th>
                                    <th>Αποσβεσμένο Ποσό</th>
                                    <th>Υπόλοιπο</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((row, idx) => {
                                    if (row.type === "previousBalance") {
                                        return (
                                            <tr key={`rfam-${idx}`} style={{backgroundColor: "lightgray", fontStyle: "italic", fontWeight: "600"}}>
                                                <td colSpan={5}>*** ΑΠΟ ΜΕΤΑΦΟΡΑ ***</td>
                                                <td>{getGreekCurrencyFormat(row.amount)}</td>
                                                <td>{getGreekCurrencyFormat(row.accumulatedDepreciation)}</td>
                                                <td>{getGreekCurrencyFormat(row.balance)}</td>
                                            </tr>
                                        )
                                    } else if (row.type === "totals") {
                                        return (
                                            <tr key={`rfam-${idx}`} style={{backgroundColor: "lightgray", fontStyle: "italic", fontWeight: "600"}}>
                                                <td colSpan={5}>*** ΣΥΝΟΛΑ ***</td>
                                                <td>{getGreekCurrencyFormat(row.amount)}</td>
                                                <td colSpan={2}></td>
                                            </tr>
                                        )
                                    } else {
                                        return (
                                            <tr key={`rfam-${idx}`}>
                                                <td>{idx + 1}</td>
                                                <td>{moment(row.date).format("DD/MM/YYYY")}</td>
                                                <td>{getRowTypeName(row)}</td>
                                                <td style={{textDecoration: "underline", textDecorationStyle: "dotted", cursor: "pointer"}} onClick={() => handleDocClick(row)}>{row.documentLabel}</td>
                                                <td>{installationOptions.find((el) => el.value === row.installation)?.label}</td>
                                                <td>{getGreekCurrencyFormat(row.amount)}</td>
                                                <td>{getGreekCurrencyFormat(row.accumulatedDepreciation)}</td>
                                                <td>{getGreekCurrencyFormat(row.balance)}</td>
                                            </tr>
                                        )
                                    }
                                })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                    <Row className={"mt-2"}>
                        <Col md={7}>
                            <BootstrapDropdown className="mb-3 mt-3">
                                <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic" disabled={loadingPrint}>
                                    Αποθήκευση αποτελεσμάτων {loadingPrint && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                </BootstrapDropdown.Toggle>
                                <BootstrapDropdown.Menu>
                                    <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                        Αποθήκευση ως PDF
                                    </BootstrapDropdown.Item>
                                    <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                        Αποθήκευση ως XLSX
                                    </BootstrapDropdown.Item>
                                </BootstrapDropdown.Menu>
                            </BootstrapDropdown>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default ReportFixedAssetMovements;
